import { ReactNode, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import { lang } from '../lang'
import { DonationType } from '@/pages/Donation/api/streamer/types'
import { useStreamerConfigContext } from '@/contexts/StreamerConfigContext/StreamerConfigContext'

type Props = {
  onSetDonationType: (value: DonationType) => void
}

export const useTypeOptions = ({ onSetDonationType }: Props) => {
  const { config } = useStreamerConfigContext()
  const isAudioEnabled = config?.audio_donation_config?.enabled ?? false

  const availableDonationTypes: {
    value: DonationType
    label: ReactNode
  }[] = [
    {
      value: DonationType.Text,
      label: (
        <Text fontSize={14} fontType="title" type="primary">
          <FormattedMessage {...lang.donationText} />
        </Text>
      ),
    },
  ]

  if (isAudioEnabled) {
    availableDonationTypes.push({
      value: DonationType.Audio,
      label: (
        <Text fontSize={14} fontType="title" type="primary">
          <FormattedMessage {...lang.donationAudio} />
        </Text>
      ),
    })
  }

  useEffect(() => {
    if (!isAudioEnabled) {
      onSetDonationType(DonationType.Text)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAudioEnabled])

  return {
    availableDonationTypes,
  }
}
